import { useV2GetProjectByIdQuery } from "@generated";

export const usePsaProjectRecord = (projectId: string) => {
  const { data, isLoading, refetch } = useV2GetProjectByIdQuery({
    id: String(projectId),
    include: ["psa-project.account-connection"] as any, // nested include; TS enum lists only top-level
  });
  const project = data?.data;
  const record = (data?.included ?? []).find(
    (r: any) => r.type === "psa-projects"
  );
  return { project, record, isLoading, refetch };
};
